import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../../lib/ep';

import QtyPicker from '../../builder/QtyPicker';
import ButtonCollection from '../../builder/ButtonCollection';
import ActionButton from '../../builder/ActionButton';

import LeveledHTMLText from '../helpers/LeveledHTMLText';
import ActionLink from '../../builder/ActionLink';
import TokenAmount, { formatTokenTitle } from './TokenAmount';
import SaveButton from '../../builder/SaveButton';

const PrizePurchaseLayer = ({ prize, tokens, user_tokens, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ units, setUnits ] = useState(1);
	const [ show_success, setShowSuccess ] = useState(false);
	const [ is_redeeming, setIsRedeeming ] = useState(false);

	const actual_token = parseInt(prize.loyalty_price[0].token);
	const available_tokens = user_tokens[actual_token];
	const cost = parseInt(prize.loyalty_price[0].amount);

	const is_builder = props?.is_builder ?? false;
	const enable_multiple_unit = false;

	const max_units = Math.floor(available_tokens / cost);

	const remaining = available_tokens - units * cost;

	const placeholder_msg = `<h1>${i18n("Prize redeemed")}</h1><p>${i18n("You'll find the prize you redeemed on your prizes page.")}</p>`;

	if(show_success) {
		return (
			<>
				<div class="redeem_success">
					<span class="main_icon ep-check-list-item" />

					<LeveledHTMLText>
						{placeholder_msg}
					</LeveledHTMLText>
				</div>

				<div class="footer_cta">
					<ButtonCollection
						_class={{ other:'flex_button' }}
					>
						<ActionButton
							_fullclass=""
							_href={`/my_prizes/${props.promotion.id}`}
						>View my prizes</ActionButton>
					</ButtonCollection>

					<ActionLink
						onClick={() => {
							setShowSuccess(false);
							props.backButton();
						}}
					>Close</ActionLink>
				</div>
			</>
		)
	}

	const claim = (cb) => {
		if(is_redeeming) return;

		if(is_builder) {
			cb();
			props.backButton();
			return;
		}

		setIsRedeeming(true);

		props.claim(prize.id, units);
		setTimeout(() => {
			cb();
			setShowSuccess(true);
			setIsRedeeming(false);
		}, 600);
	};

	const display_prize_description = props.promotion?.loyalty_display_prize_desc ?? true;

	return (
		<>
			<div class="sided_preview">
				<div class="prize_preview_info">
					<LeveledHTMLText>
						<h1>{prize.title}</h1>
					</LeveledHTMLText>

					<p class="prize_cost gui_not_in_bottom">
						<TokenAmount
							token={tokens[actual_token]}
							amount={cost}
						/>
					</p>

					<div class="prize_preview_image">
						<img
							src={(isNotEmpty(prize, 'full_image')) ? prize.full_image : `${window.cdn_url}img/default_prize_img.png`}
							width="100%"
							class="prize_img"
						/>
					</div>

					{(enable_multiple_unit) && (
						<QtyPicker
							max_units={max_units}
							onUpdateUnits={setUnits}
						/>
					)}

					{(display_prize_description && isNotEmpty(prize, 'description')) && (
						<LeveledHTMLText>
							<p dangerouslySetInnerHTML={{ __html:prize.description }} />
						</LeveledHTMLText>
					)}
				</div>
			</div>

			<div class="footer_cta">
				<ButtonCollection
					_class={{ other:'flex_button' }}
				>
					<SaveButton
						_fullclass=""
						onClick={(e, cb) => claim(cb)}
						disabled={(is_redeeming) ? true : false}
					>Redeem now</SaveButton>
				</ButtonCollection>

				<p
					class="remaining_tokens"
					dangerouslySetInnerHTML={{
						__html:props.intl.formatMessage({
							id:"If you redeem now you'll have {num} {coin_name} left"
						}, {
							num:remaining,
							coin_name:formatTokenTitle(tokens[actual_token], remaining),
						}),
					}}
				/>
			</div>
		</>
	)
};

export default injectIntl(PrizePurchaseLayer);